module.exports = __webpack_public_path__ + "static/media/watercolorsmakemesmile-IG-3.d2f4060f.PNG";